import React from 'react';
import { Select } from 'antd';

// eslint-disable-next-line react/prop-types
function DropDown({ name, options, value, label, onChange }) {
  const handleChange = (v) => onChange({ target: { name, value: v } });

  return (
    <>
      {label && <label>{label}</label>}
      <Select
        style={{ width: '100%' }}
        value={value ?? null}
        onChange={handleChange}
        allowClear
        placeholder="Select value..."
        options={[{ value: null, label: '-' }, ...(options || [])]}
      />
    </>
  );
}

export default DropDown;
